<template>
  <section class="invite-employee-page">
    <div class="page-container">
      <div class="page-header">
        <div class="header-left">
          <button class="back-btn" @click="$router.go(-1)">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="title-group">
            <h1 class="page-title">
              {{ $route.query.id ? "Edit Invite" : "Invite Employee" }}
            </h1>
            <p class="page-subtitle">
              {{ $route.query.id
                  ? "Make changes and resend to your employee"
                  : "Send invite to your employees to join your stock options plan"
              }}
            </p>
          </div>
        </div>
        <div class="header-badge">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.1667 17.5V15.8333C14.1667 14.9493 13.8155 14.1014 13.1904 13.4763C12.5652 12.8512 11.7174 12.5 10.8333 12.5H4.16667C3.28261 12.5 2.43477 12.8512 1.80964 13.4763C1.18452 14.1014 0.833336 14.9493 0.833336 15.8333V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.5 9.16667C9.34095 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34095 2.5 7.5 2.5C5.65905 2.5 4.16667 3.99238 4.16667 5.83333C4.16667 7.67428 5.65905 9.16667 7.5 9.16667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M19.1667 17.5V15.8333C19.166 15.0948 18.9203 14.3773 18.4678 13.7936C18.0153 13.2099 17.3818 12.793 16.6667 12.6083" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.3333 2.60834C14.0503 2.79192 14.686 3.20892 15.1397 3.79359C15.5935 4.37827 15.8398 5.09736 15.8398 5.8375C15.8398 6.57765 15.5935 7.29674 15.1397 7.88141C14.686 8.46609 14.0503 8.88309 13.3333 9.06667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Employee Benefits</span>
        </div>
      </div>

      <EmployeeInviteForm @submit="saveInviteInfo" />
      
      <Acknowledgment
        :inviteInfo="employee"
        :show="showAcknowledgementModal"
        v-if="showAcknowledgementModal"
        @send-invite="sendEmployeeInvite"
        @close="showAcknowledgementModal = false"
      />
    </div>
  </section>
</template>

<script>
import CustomButton from "@/components/general/BtnComponent";
import Modal from "@/components/general/Modal";
import { convertToLocale, formatAmountToDollar } from "@/utils/helpers.js";
import { mapActions, mapGetters } from "vuex";
import EmployeeInviteForm from "@/components/employeesBenefit/forms/EmployeeInviteForm";
import InputField from "@/components/general/InputField";
import Acknowledgment from "@/components/employeesBenefit/Acknowledgment";

export default {
  name: "InviteEmployee",
  
  data() {
    return {
      employee: null,
      acknowledgement_name: "",
      validationResult: [],
      showAcknowledgementModal: false,
      validateForm: false,
    };
  },
  
  components: {
    Modal,
    CustomButton,
    InputField,
    EmployeeInviteForm,
    Acknowledgment,
  },
  
  created() {
    this.fetchVestingSchedule();
  },
  
  watch: {
    validationResult: {
      deep: true,
      handler(val) {
        if (
          this.showAcknowledgementModal &&
          val.length === 1 &&
          !val.includes(false)
        ) {
          this.sendEmployeeInvite();
        }
      },
    },
  },
  
  computed: {
    ...mapGetters("Esop", ["employeeInfo"]),
    originUrl() {
      let originUrl = null;
      switch (window.location.host) {
        case "founders.getequity.io":
          originUrl = "https://app.getequity.io";
          break;
        default:
          originUrl = "https://staging--getequityinvestors.netlify.app";
          break;
      }
      return originUrl;
    },
  },
  
  methods: {
    ...mapActions(["showToast", "updateMultipleDoc"]),
    ...mapActions("Esop", [
      "getVestingSchedule",
      "getEsopToken",
      "InviteEmployee",
      "updateEmployeeInvite",
    ]),
    formatAmountToDollar,
    convertToLocale,
    
    saveInviteInfo(employee) {
      if (!employee.name || !employee.email || !employee.role) return;
      this.employee = employee;
      this.showAcknowledgementModal = true;
    },
    
    checkFormValidation() {
      this.validationResult = [];
      this.validateForm = true;
      setTimeout(() => {
        this.validateForm = false;
      }, 1000);
    },
    
    storeValue(object) {
      this[object.name] = object.value;
    },
    
    handleValidation(value) {
      this.validationResult.push(value);
    },
    
    async fetchVestingSchedule() {
      try {
        await Promise.all([this.getVestingSchedule(), this.getEsopToken()]);
      } catch (error) {
        return error;
      }
    },
    
    trimDocuments() {
      const inviteId = this.$route.query.id;
      this.employee.documents.map((document) => {
        delete document.uploader_model;
        delete document._id;
        if (inviteId && document.createdAt) {
          document.employeeInviteId = this.employeeInfo._id;
        }
        delete document.createdAt;
        delete document.kyc_request;
        delete document.updatedAt;
        delete document.uploader;
        delete document.__v;
      });
    },
    
    async sendEmployeeInvite(name) {
      this.showAcknowledgementModal = false;
      const url = `${this.originUrl}/dashboard/employee-stocks`;
      this.trimDocuments();
      const inviteId = this.$route.query.id;
      let response = null;
      let message = null;
      try {
        if (inviteId) {
          const payload = {
            ...this.employee,
            acknowledgement_name: name,
          };
          const documents = this.employee.documents;
          delete payload.email;
          delete payload.name;
          delete payload.documents;
          const docPayload = {
            params: { doc_type: "Esop_invite" },
            documents: { documents },
          };
          response = await Promise.all([
            this.updateEmployeeInvite({
              payload,
              id: inviteId,
            }),
            this.updateMultipleDoc(docPayload),
          ]);
          message = response[1].data.message;
        } else {
          const payload = {
            ...this.employee,
            acknowledgement_name: name,
            mail_base_url: url,
          };
          response = await this.InviteEmployee(payload);
          message = response.data.message;
        }
        this.showToast({
          description: message,
          display: true,
          type: "success",
        });
        this.$router.push({ name: "EmployeeBenefits" });
      } catch (error) {
        return error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.invite-employee-page {
  @include fadeIn;
  padding: 24px 20px 48px;
  min-height: 100vh;
  background: #F8FAFC;
}

.page-container {
  max-width: 900px;
  margin: 0 auto;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 16px;
}

.header-left {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  margin-top: 2px;

  &:hover {
    background: white;
    border-color: #4D84FF;
    color: #4D84FF;
  }
}

.title-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.page-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #0F172A;
  margin: 0;
}

.page-subtitle {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  color: #64748B;
  margin: 0;
}

.header-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #EEF2FF;
  border-radius: 8px;
  color: #4D84FF;
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
}
</style>
